var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M68 12C69.0506 10.9494 70.2978 10.1161 71.6704 9.54748C73.0431 8.97892 74.5143 8.68628 76 8.68628C77.4857 8.68628 78.9569 8.97892 80.3296 9.54748C81.7022 10.1161 82.9494 10.9494 84 12C85.0506 13.0506 85.8839 14.2978 86.4525 15.6704C87.0211 17.0431 87.3137 18.5143 87.3137 20C87.3137 21.4857 87.0211 22.9569 86.4525 24.3296C85.8839 25.7022 85.0506 26.9494 84 28L30 82L8 88L14 66L68 12Z","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Edit.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Edit;

Edit.default = Edit;
